<!--  -->
<template>
  <div class="center">
    <!-- 头部 -->
    <heads class="head"></heads>
    <!-- 个人信息 -->
    <!-- <info class="info"></info> -->
    <!-- 内容 -->
    <!-- <div class="nr">
      <div class="neirong">
        <left class="left"></left>
        <router-view class="right" />
      </div>
    </div> -->
    <router-view />
    <!-- 底部 -->
    <foot class="foot"></foot>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import heads from "../components/header";
import foot from "../components/foot";
import info from "../components/info";
import left from "../components/left";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { heads, foot, info, left },
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //方法集合
  methods: {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less">
/*@import url(); 引入公共css类*/
.center {
  height: 100%;
}
.head {
  height: 4rem;
}
.foot {
  height: 4rem;
}
.info {
}
.nr {
  width: 100%;
  display: flex;
  justify-content: center;
}
.neirong {
  width: 88%;
  display: flex;
  margin-bottom: 1.5rem;
  justify-content: space-between;
  .left {
    width: 10rem;
    flex-direction: column;
    align-items: center;
    font-size: 00.8rem;
    // div {
    //   padding: 00.6rem 0rem;
    //   display: flex;
    //   justify-content: center;
    // }
  }
  .right {
    width: 84% !important;
  }
}
</style>